import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { StatusArea } from "./Styles";

export default function Status({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="Estatus"
            value={!value ? document.status.description : value}
          />
        </div>
      ) : (
        <StatusArea>
          <Informative
            readonly={true}
            label="Estatus"
            value={!value ? document.status.description : value}
          />
        </StatusArea>
      )}
    </>
  );
}
